import React, { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faChartPie, faSearchDollar } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';

const PaymentAdvanceCountCard = () => {
  const [paymentRequestCount, setPaymentRequestCount] = useState(0);
  const { paymentAdvances } = useContext(DataContext); // Assuming paymentAdvances is the array of payment requests

  useEffect(() => {
    // Directly using paymentAdvances from DataContext assuming it's already fetched
    setPaymentRequestCount(paymentAdvances.length);

    // If you need to fetch or update data, ensure DataContext provides a method for it and call it here
    // fetchData(); // Uncomment if needed
  }, [paymentAdvances]); // Depend on paymentAdvances so it updates when paymentAdvances changes

  // You might want to segment payment requests by status, type, etc., if your data model supports it
  // This example simply shows the count of all payment requests

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg h-custom-card-small">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faSearchDollar} className="text-green-600 mr-3" />
          Payment Advances
        </h2>
        <a href="/payment-requests" className="text-md text-green-600 hover:text-green-800 transition duration-300">
          View all
        </a>
      </div>
      <div className="text-center mb-4">
        <FontAwesomeIcon icon={faMoneyBillWave} className="text-green-600 text-3xl mb-2" />
        <p className="text-md text-gray-600">Total Requests</p>
        <p className="text-2xl font-semibold text-gray-800">{paymentRequestCount}</p>
      </div>
      {/* If you have categories or statuses to display, you can add a similar segmentation display here */}
    </div>
  );
};

export default PaymentAdvanceCountCard;
